import Layout from "../pages/Layout";
import Error from "../pages/Error";
import Table from "../pages/Table";
import Subcategories from "../pages/Subcategories";
import Home from "../pages/Home";
import ViewByType from "../pages/ViewByType";
import Product from "../pages/Product";
import Support from "../pages/Support";

export const routes = [
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "/table/category/all/all",
                element: <Table />,
            },
            {
                path: "/:type",
                element: <ViewByType />,
            },
            {
                path: "/:type/:typeName",
                element: <Subcategories />,
            },
            {
                path: "/table/:type",
                element: <Table />,
            },
            {
                path: "/table/category/:categoryName/all",
                element: <Table />,
            },
            {
                path: "/table/category/:categoryName/:subcategoryName",
                element: <Table />,
            },
            {
                path: "/:categoryId/:subcategoryId/:productName",
                element: <Product />,
            },
            {
                path: "/support",
                element: <Support />,
            },
        ],
    },
    {
        path: "*",
        element: <Error />,
    },
]